import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

import { buildInfo } from '@environments/build-info';

/**
 * App footer — copyright and build stamp. The AI Help entry point used to live
 * here (FEC-1220); FEC-1227 moved it to a floating button owned by the panel.
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  protected buildVersion = signal<string>(buildInfo.GIT_COMMIT_HASH || '');
}
